module.exports = __webpack_public_path__ + "img/user1.053d2d84.jpg";